import { createFileRoute } from "@tanstack/react-router"
import { GetStartedPage } from "@/app"

export const Route = createFileRoute("/(public)/auth/")({
  component: RouteComponent,
})

function RouteComponent() {
  return <GetStartedPage />
}
